import { render } from "./TestKanbanBoard.vue?vue&type=template&id=2631b13d&scoped=true"
import script from "./TestKanbanBoard.vue?vue&type=script&lang=js"
export * from "./TestKanbanBoard.vue?vue&type=script&lang=js"

import "./TestKanbanBoard.vue?vue&type=style&index=0&id=2631b13d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2631b13d"]])

export default __exports__